<template lang="html">
    <b-container fluid>
    <b-row >
        <b-col md="6" offset-md="3" align-self="center"  d-flex h-100 flex-wrap >
            <b-img src="../assets/320x200-blade.png" center fluid alt="Responsive image" style=" margin-top:5%"/>
            <b-card title="Create Demo Account"  sub-title="" style=" margin-top:3%" v-if="!success">
                <form role="form" v-on:submit.prevent="showAndSubmitLicenseAgreement()"  v-if="!busy">
                    <fieldset>
                        <div class="form-group">
                            <input v-model="$v.form.firstName.$model"  aria-describedby="firstNameInput"  class="form-control" placeholder="First Name" name="firstName" type="text">
                            <b-alert variant="danger"  :show="($v.form.firstName.$dirty && !$v.form.firstName.required)">Field is required</b-alert>
                        </div>
                        <div class="form-group">
                            <input v-model="$v.form.lastName.$model"  aria-describedby="lastNameInput"  class="form-control" placeholder="Last Name" name="lastName" type="text">
                            <b-alert variant="danger"  :show="($v.form.lastName.$dirty && !$v.form.lastName.required)">Field is required</b-alert>
                        </div>
                        <div class="form-group">
                            <input v-model="$v.form.userName.$model" aria-describedby="userNameInput"  class="form-control" placeholder="User Name" name="userName" type="text">
                            <b-alert variant="danger"  :show="($v.form.userName.$dirty && !$v.form.userName.required)">Field is required</b-alert>
                            <b-alert :show="hasUserNameError" variant="danger" @dismissed="hasUserNameError=false">  {{errorMsg}} </b-alert>
                            <b-alert variant="danger"  :show="($v.form.userName.$dirty && !$v.form.userName.validUserName)">User names can include numbers and upper and lower case letters only</b-alert>
                        </div>
                        <div class="form-group">
                            <input v-model="$v.form.password.$model"  aria-describedby="passwordInput"  class="form-control" placeholder="Password" name="password" type="password">
                            <b-alert variant="danger"  id="passwordInput" :show="($v.form.password.$dirty && !$v.form.password.strongPassword)">
                                <p>The string must contain at least 1 lowercase alphabetical character</p>
                                <p>The string must contain at least 1 uppercase alphabetical character</p>
                                <p>The string must contain at least 1 numeric character</p>
                                <p>The string must be eight characters or longer</p>
                            </b-alert>
                        </div>
                        <div class="form-group">
                            <input  v-model="$v.form.confirmPassword.$model" aria-describedby="confirmPasswordInput"   class="form-control" placeholder="Confirm Password" name="confirmPassword" type="password" :class="status($v.form.password)">
                            <b-alert variant="danger" id="confirmPasswordInput" :show="($v.form.confirmPassword.$dirty && !$v.form.confirmPassword.sameAsPassword)">
                                passwords don't match
                            </b-alert>
                        </div>
                        <div class="form-group">
                            <input v-model="$v.form.email.$model"  aria-describedby="emailInput"  class="form-control" placeholder="Email" name="email" type="text">
                            <b-alert variant="danger"  :show="($v.form.email.$dirty && !$v.form.email.required )">Field is required</b-alert>
                            <b-alert variant="danger"  :show="($v.form.email.$dirty && !$v.form.email.email )">Enter a valid email</b-alert>
                            <!-- <br/> -->
                            <p style="font-size: 85%;">Address to which the authorization code will be sent.</P>
                        </div>
                        <div class="form-group">
                            <input v-model="$v.form.companyName.$model"  aria-describedby="companyNameInput"  class="form-control" placeholder="Company Name" name="companyName" type="text">
                            <b-alert variant="danger"  :show="($v.form.companyName.$dirty && !$v.form.companyName.required)">Field is required</b-alert>
                        </div>
                        <div class="form-group">
                            <b-form-textarea v-model="$v.form.companyAddress.$model"  aria-describedby="companyAddressInput"  class="form-control" placeholder="Company Address" name="companyAddress" type="text" :rows="2"></b-form-textarea>
                            <b-alert variant="danger"  :show="($v.form.companyAddress.$dirty && !$v.form.companyAddress.required)">Field is required</b-alert>
                        </div>
                        <div class="form-group">
                            <b-form-textarea v-model="$v.form.notes.$model"  aria-describedby="notesInput"  class="form-control" placeholder="Notes" name="notes" type="text" :rows="3"></b-form-textarea>
                        </div>
                        <div class="form-group">
                            <label class="left-align">
                              <input class="center-align" type="checkbox" name="privacyPolicy" v-model="$v.form.privacyPolicy.$model">
                              I have read and agree to the <a class="aMargin" v-on:click.prevent="showLicenseAgreement()" href="#">User Agreement</a> and <a class="aMargin" v-on:click.prevent="showPrivacyPolicy()" href="#"> Privacy Policy.</a>
                            </label>
                        </div>
                        <button type="submit" class="btn btn-lg btn-blade btn-block" v-bind:disabled="$v.form.$invalid">Create Account</button>
                    </fieldset>
                </form>
                <div class="loader"> <stretch v-if="busy" ></stretch> </div>
            </b-card>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap >
            <b-alert :show="hasError && !hasUserNameError" variant="danger" @dismissed="hasError=false">  {{errorMsg}}
            </b-alert>
                <b-alert :show="success" variant="success" @dismissed="hasError=false">
                Your demo account has been created.
                <br/>
                <!-- <b-link :to="'/'">Login</b-link> -->
            </b-alert>
            <b-link :to="'/'" v-if="!success && !busy">Cancel</b-link>
        </b-col>
    </b-row>
    <b-row>
      <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap v-if="success">
          <button v-on:click="navigateToHomePage" class="btn btn-lg btn-blade btn-block">Login</button>
      </b-col>
    </b-row>
    <div slot="footer" class="w-100">
      <license-footer></license-footer>
    </div>
    </b-container>
</template>

<script lang="js">

import { Stretch } from 'vue-loading-spinner'
import { required, email, sameAs, helpers } from 'vuelidate/lib/validators'
import LicenseFooter from './LicenseFooter'

const strongPassword = helpers.regex('strongPassword', /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/)
const validUserName = helpers.regex('validUserName', /^[a-zA-Z0-9_-]+$/)

export default {
  name: 'CreateDemoUser',
  components: { Stretch, LicenseFooter },
  data () {
    return {
      busy: false,
      hasError: false,
      hasUserNameError: false,
      errorMsg: '',
      success: false,
      invalidDomains: [ 'uorak.com', 'boxmail.lol' ],
      form: {
        firstName: '',
        lastName: '',
        userName: '',
        password: '',
        confirmPassword: '',
        email: '',
        companyName: '',
        companyAddress: '',
        notes: '',
        privacyPolicy: false
      }
    }
  },
  mounted () {
    const self = this
    self.$eventBus.$once('license-agreement-accepted-cdu', () => {
      self.createdemouseraccount()
    })
  },
  validations: {
    form: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      userName: {
        required,
        validUserName
      },
      password: {
        required,
        strongPassword
      },
      confirmPassword: {
        sameAsPassword: sameAs('password')
      },
      email: {
        email,
        required
      },
      companyName: {
        required
      },
      companyAddress: {
        required
      },
      notes: {
      },
      privacyPolicy: {
        sameAs: sameAs(() => true)
      }
    }
  },
  methods: {
    navigateToHomePage () {
      this.$router.push('/')
    },

    showPrivacyPolicy () {
      this.$eventBus.$emit('show-privacy-policy')
    },

    showLicenseAgreement () {
      this.$eventBus.$emit('show-license-agreement')
    },

    showAndSubmitLicenseAgreement () {
      this.$eventBus.$emit('show-license-agreement', 'Accept', 'cdu')
    },

    isValidDomain () {
      const self = this
      let email = self.form.email.trim()
      let emailDomain = email.split('@')[1].toLowerCase()
      if (self.invalidDomains.includes(emailDomain) || emailDomain.endsWith('.ru')) {
        return false
      }
      return true
    },

    createdemouseraccount () {
      const self = this
      const INVALID_EMAIL = 'Invalid e-mail address. Please contact Support at support@stringnosis.com.'
      if (!self.isValidDomain()) {
        self.hasError = true
        self.errorMsg = INVALID_EMAIL
        self.$eventBus.$once('license-agreement-accepted-cdu', () => {
          self.createdemouseraccount()
        })
      } else {
        const INVALID_USERNAME_MSG = 'Username cannot be of email format, since user pool is configured for email alias.'
        const INVALID_USERNAME_DISPLAY_MSG = 'User names can only contain letters and numbers'
        const USER_EXISTS = 'User account already exists' // 'User account already exists and is expired. Please call with action RESEND to reset user account'
        const USER_EMAIL_EXISTS = 'An account with the email already exists.'
        let firstName = self.form.firstName.trim()
        let lastName = self.form.lastName.trim()
        let userName = self.form.userName.trim()
        let password = self.form.password.trim()
        let email = self.form.email.trim()
        let companyName = self.form.companyName.trim()
        let companyAddress = self.form.companyAddress.trim()
        let notes = self.form.notes.trim()

        self.hasError = false
        self.hasUserNameError = false
        self.busy = true
        self.$auth.createDemoUserAccount(firstName, lastName, userName, password, email, companyName, companyAddress, notes).then(response => {
          self.busy = false
          self.success = true
        })
          .catch(err => {
            if (err) {
              self.hasError = true
              self.busy = false
              if (err.response && err.response.data.includes(INVALID_USERNAME_MSG)) {
                self.errorMsg = INVALID_USERNAME_DISPLAY_MSG
                self.hasUserNameError = true
              } else if (err.response && err.response.data.includes(USER_EXISTS)) {
                self.errorMsg = USER_EXISTS
              } else if (err.response && err.response.data.includes(USER_EMAIL_EXISTS)) {
                self.errorMsg = INVALID_EMAIL
              } else {
                self.errorMsg = 'Error occurred. Please try again.'
              }
              this.$eventBus.$once('license-agreement-accepted-cdu', () => {
                self.createdemouseraccount()
              })
            }
          })
      }
    },
    status (validation) {
      console.log(`error: ${validation.$error}`)
      console.log(`dirty: ${validation.$dirty}`)
      console.log(`strong: ${validation.strongPassword}`)
      console.log(`validUser: ${validation.validUserName}`)
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    }
  },
  computed: {
  }
}
</script>

<style src="../assets/styles.css">

</style>



// WEBPACK FOOTER //
// src/components/CreateDemoUser.vue